import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { ProcessWheel } from "../../api/getProcessWheels/types";

interface ProcessWheelActionMenuProps {
  processWheel: ProcessWheel;
  onView: (processWheel: ProcessWheel) => void;
  onEdit: (processWheel: ProcessWheel) => void;
  onDelete: (processWheel: ProcessWheel) => void;
}

const ProcessWheelActionMenu: React.FC<ProcessWheelActionMenuProps> = ({
  processWheel,
  onView,
  onEdit,
  onDelete,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="h-8 w-8 p-0 hover:bg-gray-200 transition-colors"
          variant="ghost"
        >
          <span className="sr-only">Open menu</span>
          <EllipsisVerticalIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[150px] p-2 bg-white">
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={() => onView(processWheel)}
        >
          View
        </DropdownMenuItem>
        <DropdownMenuItem
          className={`flex items-center px-3 py-2 text-sm transition-colors ${
            processWheel.isDeleted
              ? "cursor-not-allowed text-gray-400"
              : "cursor-pointer hover:bg-gray-100"
          }`}
          disabled={processWheel.isDeleted}
          onClick={() => !processWheel.isDeleted && onEdit(processWheel)}
          title={
            processWheel.isDeleted
              ? "Inactive process wheels can't be edited."
              : undefined
          }
        >
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem
          className={`flex items-center px-3 py-2 text-sm transition-colors ${
            processWheel.canBeDeleted
              ? "cursor-pointer text-red-600 hover:bg-gray-100"
              : "cursor-not-allowed text-gray-400"
          }`}
          disabled={!processWheel.canBeDeleted}
          onClick={() => processWheel.canBeDeleted && onDelete(processWheel)}
          title={
            processWheel.canBeDeleted
              ? undefined
              : "This process wheel can't be deleted — it's already deleted."
          }
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ProcessWheelActionMenu;
